export const ALL_NOTIFICATIONS_REQUEST = "ALL_NOTIFICATIONS_REQUEST";
export const ALL_NOTIFICATIONS_SUCCESS = "ALL_NOTIFICATIONS_SUCCESS";
export const ALL_NOTIFICATIONS_FAIL = "ALL_NOTIFICATIONS_FAIL";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
